import { useSnackbar } from "notistack";
import React, { createContext, useContext, useEffect } from "react";
import { AppstoreApi, updateAppsInfo, usGetUserInfo } from "../../api";
import { CredentialDialog } from "../../components/CredentialDialog";
import { useCombineReducer } from "../../hooks/useCombineReducer";
import { useAuth } from "../AuthProvider";
import { setDeletingApp } from "./actions/appDeleteActions";
import { appDeletionReducer } from "./reducers/appDeleteReducer";
import {
  appDetailReducer,
  AppDetailsActionType,
} from "./reducers/appDetailsReducer";
import { globalReducer } from "./reducers/globalReducer";
import {
  appInstallationReducer,
  AppActionType,
} from "./reducers/appInstallReducer";
import { cloudServiceBaseUrl, userServiceBaseUrl } from "../../config";
import axios from "axios";
import { authTokenPayload } from "../../config/constant";
const AppContext = createContext({
  state: {},
  dispatch: () => {},
});

export default function AppProvider({ children }) {
  const { enqueueSnackbar } = useSnackbar();

  const [state, dispatch] = useCombineReducer({
    appInstall: appInstallationReducer,
    appDetails: appDetailReducer,
    appDelete: appDeletionReducer,
    globalReducer,
  });
  const {
    appInstall,
    appDetails: { appDetails },
  } = state;
  const { userInfo, refreshUserInfo } = useAuth();
  const { userPassword } = state.globalReducer;

  const final_step = (appid) => {
    const downloading_apps = sessionStorage.getItem("downloading_apps")
      ? JSON.parse(sessionStorage.getItem("downloading_apps"))
      : [];

    sessionStorage.setItem(
      "downloading_apps",
      JSON.stringify([...(downloading_apps || [])?.filter((x) => x !== appid)])
    );
  };

  useEffect(() => {
    const func = async () => {
      if (appInstall.installationQueue.length > 0 && !appInstall.appToInstall) {
        const appid = appInstall.installationQueue[0];

        dispatch({
          type: AppActionType.SET_INSTALLING_APP,
          payload: { appid },
        });

        const downloading_apps = sessionStorage.getItem("downloading_apps")
          ? JSON.parse(sessionStorage.getItem("downloading_apps"))
          : [];

        sessionStorage.setItem(
          "downloading_apps",
          JSON.stringify([...(downloading_apps || []), appid])
        );

        try {
          const service = userServiceBaseUrl; // sessionStorage.getItem('userservice')
          let domain;
          let port;
          let api_key = userInfo?.apikey;
          let us;

          let forum_uri = userInfo?.apps?.find(
            (x) =>
              x?.appid?.startsWith("comvm") ||
              x?.appid?.startsWith("basvm") ||
              x?.appid?.startsWith("provm")
          )?.forum_uri;

          if (forum_uri) {
            us = forum_uri;

            try {
              await usGetUserInfo(
                us,
                authTokenPayload({
                  userid: userInfo?.userid,
                })
              ).then((res) => {
                api_key = res?.apikey;
              });
            } catch (error) {}
          } else if (userInfo?.parent_user_service) {
            us = userInfo?.parent_user_service + ":18080";

            try {
              await usGetUserInfo(
                us,
                authTokenPayload({
                  userid: userInfo?.userid,
                })
              ).then((res) => {
                api_key = res?.apikey;
              });
            } catch (error) {}
          }

          if (userInfo?.parent_user_service) {
            const url = userInfo?.parent_user_service?.split(":");
            domain = url?.[0];
            port = "18080";
          } else {
            const url = service?.split(":");
            domain = url?.[0];
            port = "18080";
          }

          await AppstoreApi.usUpdateApp(
            api_key,
            {
              userid: userInfo.userid,
              apikey: userInfo.apikey,
              appid,
              appstore_us_ip: domain,
              appstore_us_port: port,
            },
            forum_uri
          )
            .then(async (res) => {
              const { errcode } = res;
              if (errcode === -1) {
                try {
                  const email_payload = {
                    mail_template_key:
                      "2518b.2f361ca8e178de0f.k1.7c0459a0-b44f-11ee-8f1b-525400674725.18d118be43a",
                    from: {
                      address: "admin@bangdb.com",
                      name: "BangDB NoSQL",
                    },
                    to: [
                      {
                        email_address: {
                          address: userInfo.email,
                          name:
                            userInfo?.first_name +
                            (userInfo?.last_name
                              ? " " + userInfo?.last_name
                              : ""),
                        },
                      },
                    ],
                    merge_info: {
                      subject: "App Installation Failed",
                      team: "BangDB",
                      first_name: userInfo?.first_name,
                      product_name: appid,
                    },
                    subject: `App Installation Failed`,
                  };

                  await axios.post(
                    `https://${cloudServiceBaseUrl}/auth/zeptoMail/send_mail`,
                    email_payload
                  );
                } catch (error) {
                  console.log(error);
                }
                enqueueSnackbar("App installation failed", {
                  variant: "error",
                });
              } else {
                if (appInstall?.successFunction) {
                  appInstall?.successFunction();
                }

                const app = appDetails?.find((x) => x?.appid === appid);

                if (us && !userInfo?.parent_user_service) {
                  try {
                    await updateAppsInfo(
                      {
                        userid: userInfo?.userid,
                        apikey: us === forum_uri ? userInfo?.apikey : api_key,
                        app_info: {
                          appid,
                          app_name: app?.name,
                          installed_by: userInfo?.userid,
                          installed_ts: Date.now() * 1000,
                          version: app?.version,
                          state: 1,
                        },
                      },
                      !forum_uri &&
                        !["L1", "L2", "L3"].includes(userInfo?.license)
                        ? userInfo?.parent_user_service + ":18080"
                        : undefined
                    );

                    refreshUserInfo();
                  } catch (error) {}
                }

                enqueueSnackbar("App installed successfully", {
                  variant: "success",
                });

                try {
                  const email_payload = {
                    mail_template_key:
                      "2518b.2f361ca8e178de0f.k1.1f983380-ac7a-11ee-b95b-525400b0b0f3.18cde358eb8",
                    from: {
                      address: "admin@bangdb.com",
                      name: "BangDB NoSQL",
                    },
                    to: [
                      {
                        email_address: {
                          address: userInfo.email,
                          name:
                            userInfo?.first_name +
                            (userInfo?.last_name
                              ? " " + userInfo?.last_name
                              : ""),
                        },
                      },
                    ],
                    merge_info: {
                      password:
                        userPassword ||
                        "same as your current platform password.",
                      subject: "App Installation Successful",
                      first_name: userInfo?.first_name,
                      userid: userInfo?.userid,
                      ampere_uri: process.env.REACT_APP_AMPERE_URI,
                    },
                    subject: `App Installation Successful`,
                  };

                  await axios.post(
                    `https://${cloudServiceBaseUrl}/auth/zeptoMail/send_mail`,
                    email_payload
                  );
                } catch (error) {
                  console.log(error);
                }
                if (appInstall.config === "BugTracker") {
                  await AppstoreApi.putDocInStream(
                    `${appid}_BugTracker`,
                    "Priority_reference_set",
                    JSON.stringify([
                      { Zoho_Priority: "Show stopper", BangDB_Priority: 0 },
                      { Zoho_Priority: "Critical", BangDB_Priority: 1 },
                      { Zoho_Priority: "Major", BangDB_Priority: 2 },
                      { Zoho_Priority: "Minor", BangDB_Priority: 3 },
                    ])
                  );
                }
              }
              const ser = sessionStorage.getItem("userservice");
              const amp = sessionStorage.getItem("amp");
              await refreshUserInfo(userInfo.userid, userInfo.apikey, ser, amp);
              dispatch({
                type: AppActionType.APP_INSTALLED,
                payload: { appid: appid },
              });
            })
            .catch((error) => {
              console.log(error);

              enqueueSnackbar(
                "App Installed Failed, Please retry after some time!",
                {
                  variant: "error",
                }
              );

              dispatch({
                type: AppActionType.SET_INSTALLING_APP,
                payload: { appid: null },
              });

              dispatch({
                type: AppActionType.REMOVE_FROM_INSTALLATION_QUEUE,
                payload: { appid: appid },
              });
            });
        } catch (error) {
          console.log(error);
        } finally {
          final_step(appid);
        }
      }
    };

    func();
  }, [
    appInstall.appToInstall,
    appInstall.installationQueue,
    dispatch,
    enqueueSnackbar,
    refreshUserInfo,
    userInfo.apikey,
    userInfo.userid,
  ]);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
      <CredentialDialog
        onSubmit={(credential) => {
          const { id, password } = credential;
          AppstoreApi.deleteApp(state.appDelete.appToDelete, id, password)
            .then((data) => {
              const {
                errcode,
                // msg
              } = data;
              if (errcode === 0) {
                enqueueSnackbar("App Deleted Succesfully", {
                  variant: "success",
                });
                dispatch({
                  type: AppDetailsActionType.REMOVE_APP_DETAILS,
                  payload: { appid: state.appDelete.appToDelete },
                });
              } else if (errcode === -1) {
                enqueueSnackbar("Unable to Delete App", {
                  variant: "error",
                });
              } else if (data?.installed_by) {
                enqueueSnackbar(
                  "App is still in use by some accounts hence Unable to Delete App",
                  {
                    variant: "error",
                  }
                );
              }
              setDeletingApp(null);
            })
            .catch(console.log);
        }}
        open={Boolean(state.appDelete.appToDelete)}
        onClose={() => {
          dispatch(setDeletingApp(null));
        }}
      />
    </AppContext.Provider>
  );
}

export function useAppProvider() {
  return useContext(AppContext);
}
